import apiClient from '../client';
import { AxiosError } from 'axios';

export interface UploadResult {
  rowsProcessed: number;
  message: string;
}

export interface ValidationError {
  row: number;
  column: string;
  message: string;
}

export interface ValidationFailure {
  isValidation: true;
  message: string;
  errors: ValidationError[];
}

export async function uploadRetailerPricesCSV(file: File): Promise<UploadResult | ValidationFailure> {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await apiClient.post<{ success: boolean; message: string; rowsProcessed?: number }>(
      '/configurator-uploads/upload',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        validateStatus: (status) => status < 500,
      }
    );

    if (response.status === 400) {
      const body = response.data as { message: string; errors?: ValidationError[] };
      return {
        isValidation: true,
        message: body.message,
        errors: body.errors ?? [],
      };
    }

    return {
      rowsProcessed: response.data.rowsProcessed ?? 0,
      message: response.data.message,
    };
  } catch (err) {
    const axiosErr = err as AxiosError<{ message?: string }>;
    throw new Error(axiosErr.response?.data?.message ?? axiosErr.message ?? 'Upload failed');
  }
}
